import { Injectable } from '@angular/core';
import { JSEncrypt } from 'jsencrypt';
@Injectable({
    providedIn: 'root',
  })
export class EncripteService  {

 publicKey = '-----BEGIN PUBLIC KEY-----\n' +
 'MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAtbXkFU5LHfTInVj9lsPc\n' +
 'DAN4fC3Bne8VxUvKknpjXuztffMuF+Vkh8iWWH7opuvpLaRok5aD/6ZgMP0QTr5y\n' +
 '0rV6M7mcB546pUuBRW89xqtyf2LB0Xsr9FsO9yDO1k7YlqeT//jvTLXKDXG5F8lc\n' +
 'hkb4MW59aJ6vjjfyZq4MRinPCvJ6OgqGqs3+dWIq4tKYBjPFEoHJtXnCKvng9XEe\n' +
 'D9w1YYlGt2OOrqQroHDzGCWhNwpUq15hgd6ZrsBiNuAtGEkHXjIb2O9ZvqUaAqI9\n' +
 'thWuXp5EooUeREOgoidR+lXFN3Qd5kCKUTYUQXilXkq8rCm0jXXvGERFEPWQmCu5\n' +
 'BQIDAQAB\n' +
 '-----END PUBLIC KEY-----';
  private encryptor: JSEncrypt;

  constructor() {
    this.encryptor = new JSEncrypt();
    this.encryptor.setPublicKey(this.publicKey);
  }


  encryptData(data: string): string {
    const encrypted = this.encryptor.encrypt(data);
    if (encrypted === false) {
      throw new Error('Encryption failed');
    }
    return encrypted;
  }

}
